"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _UpsellItem = _interopRequireDefault(require("./UpsellItem"));
var _UpsellTotalCost = _interopRequireDefault(require("./UpsellTotalCost"));
var _UpsellSectionRow = _interopRequireDefault(require("./UpsellSectionRow"));
var _useRecommendationCosts = require("../../hooks/recommendation/useRecommendationCosts");
var _useUpsellCosts = _interopRequireDefault(require("../../hooks/upsell/useUpsellCosts"));
var _services = require("../../services");
var _useQuestionsMetadata = require("../../hooks/questionnaire/useQuestionsMetadata");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const UpsellBreakdown = () => {
  const {
    products
  } = (0, _useUpsellCosts.default)();
  const planLines = (0, _useQuestionsMetadata.useQuestionsMetadata)({
    flag: 'plan',
    keyPath: 'filters.lines[0]'
  });
  const getPlanLinesNumber = productType => {
    if (productType !== _constants.PRODUCT_TYPES.PLAN) return null;
    if (planLines === '2lines') return 2;
    if (planLines === '3lines') return 3;
    if (planLines === '4lines') return 4;
    return null;
  };
  const {
    totalUpfrontCost,
    totalTermCost
  } = (0, _useRecommendationCosts.useRecommendationCosts)();
  const BreakdownTable = () => {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: 3
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_UpsellSectionRow.default, null))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, products.map((product, index) => {
      const {
        name,
        price,
        productType,
        selectedPrice
      } = product;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: index
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_UpsellItem.default, {
        productType: productType,
        title: name,
        price: price === null || price === void 0 ? void 0 : price[0],
        selectedPrice: selectedPrice,
        linesQty: getPlanLinesNumber(productType)
      }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null))));
    }))));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    marginBottom: 3
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    level: 4,
    weight: 3,
    text: `${_services.locale.localeString('RelationshipOffer.Summary')}`
  }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(BreakdownTable, null))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_UpsellTotalCost.default, {
    totalUpfront: totalUpfrontCost,
    totalRecurring: totalTermCost
  }))));
};
var _default = UpsellBreakdown;
exports.default = _default;